import { ECSBehaviorTreeBuilder } from '../builders/ECSBehaviorTreeBuilder';
import { BehaviorTreeComponent } from '../components/BehaviorTreeComponent';
import { TaskStatus } from '../../behaviourTree/TaskStatus';
/**
 * 行为树工厂
 * 提供常用的行为树模板和快速创建方法
 */
export class BehaviorTreeFactory {
    /**
     * 为实体快速添加行为树
     */
    static addBehaviorTreeToEntity(entity, treeBuilder, options = {}) {
        const builder = new ECSBehaviorTreeBuilder(entity);
        const configuredBuilder = treeBuilder(builder);
        const tree = configuredBuilder.buildECSTree(options.updateInterval || 0.1);
        const behaviorTreeComp = entity.addComponent(new BehaviorTreeComponent());
        behaviorTreeComp.setBehaviorTree(tree);
        behaviorTreeComp.updateInterval = options.updateInterval || 0.1;
        behaviorTreeComp.debugMode = options.debugMode || false;
        behaviorTreeComp.treeName = options.treeName || `Tree_${entity.name}`;
        if (options.autoStart !== false) {
            behaviorTreeComp.start();
        }
        return behaviorTreeComp;
    }
    /**
     * 创建简单的巡逻行为树
     */
    static createPatrolBehavior(waypoints, speed = 100, waitTime = 1.0) {
        let currentWaypointIndex = 0;
        return (builder) => {
            return builder
                .selector()
                .sequence()
                .action((entity) => {
                const waypoint = waypoints[currentWaypointIndex];
                console.log(`实体 ${entity.id} 移动到巡逻点 ${currentWaypointIndex}: (${waypoint.x}, ${waypoint.y})`);
                // 这里可以实现实际的移动逻辑
                // 例如：获取PositionComponent并移动
                return TaskStatus.Success;
            })
                .waitAction(waitTime)
                .action((entity) => {
                // 切换到下一个巡逻点
                currentWaypointIndex = (currentWaypointIndex + 1) % waypoints.length;
                return TaskStatus.Success;
            })
                .endComposite()
                .endComposite();
        };
    }
    /**
     * 创建简单的追击行为树
     */
    static createChaseTargetBehavior(targetTag, chaseRange = 200) {
        return (builder) => {
            return builder
                .action((entity) => {
                console.log(`实体 ${entity.id} 正在执行追击行为，目标标签: ${targetTag}`);
                return TaskStatus.Success;
            });
        };
    }
    /**
     * 创建生命值监控行为树
     */
    static createHealthMonitoring(healthComponentType, lowHealthThreshold = 30) {
        return (builder) => {
            return builder
                .action((entity) => {
                console.log(`实体 ${entity.id} 正在监控生命值`);
                return TaskStatus.Success;
            });
        };
    }
}
//# sourceMappingURL=BehaviorTreeFactory.js.map